import React from 'react'
import {Tabs,Container} from 'react-bootstrap'
import ClinicalCriteria from "./DiagnosticCriteria/clinicalcriteria"
import Diagnosis from "./Diagnosis/diagnosis"
import Medical_Notes from './MedicalNotes/medical_notes'
function ClinicalAndDiagnosis(props){
    return(
        <Tabs>
        <Tabs.Tab eventKey={'diagnosis'} title={"Diagnosis"}>
                <Diagnosis handler={props.handler1} disabled={props.disabled} data={props.data!=null?props.data['diagnosis']:null}/>
        </Tabs.Tab>
        <Tabs.Tab eventKey={'clinical_criteria'} title={"Diagnostic Criteria"}>
                <ClinicalCriteria handler={props.handler1} disabled={props.disabled}
                    handlePspMsaAuto={props.handlePspMsaAuto} handleMsaNew={props.handler} data={props.data!=null ?{"clinical_psp":props.data['clinical_psp'],
                    "clinical_msa":props.data['clinical_msa'],"clinical_parkinson_disease":props.data['clinical_parkinson_disease']
                    ,"unclassified_parkinsonism":props.data['unclassified_parkinsonism'],
                    "umsars_new":props.data['umsars_new']}
                    :null}
                />
        </Tabs.Tab>
        <Tabs.Tab eventKey={'medical_notes'} title={"Medical Notes"}>
                <Medical_Notes handler={props.handler1} disabled={props.disabled} data={props.data!=null?props.data['medical_notes']:null}/>
        </Tabs.Tab>
        </Tabs>
    )
}
ClinicalAndDiagnosis.defaultProps ={
    data:null
}
export default ClinicalAndDiagnosis;